import React from 'react';
import { connect } from 'react-redux';

import { getRouteIsLoading, getLoadedRoute } from 'dux/router/selectors';
import { getComponent } from 'dux/router/component-loader';

import LoadingOverlay from 'components/shared/loading-overlay';

interface Props {
    routeIsLoading: boolean;
    routeType: string;
}

export class AsyncRenderer extends React.Component<Props> {
    public static defaultProps = {
        routeIsLoading: true,
        routeType: '',
    };

    public render() {
        const { routeIsLoading, routeType } = this.props;
        const Component = getComponent(routeType);
        const isLoading = routeIsLoading || !Component;

        return [
            <LoadingOverlay isLoading={isLoading} key="loader" />,
            !isLoading && <Component key="component" />,
        ];
    }
}

export default connect((state) => ({
    routeIsLoading: getRouteIsLoading(state),
    routeType: getLoadedRoute(state) || '',
}))(AsyncRenderer);
